// Domain helpers: every URL is derived from the domain the app is currently opened on,
// so the same build works on essuivi.com, any other domain, or localhost.

const isLocalhost = () => ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Frontend origin, e.g. "https://essuivi.com"
export const getAppOrigin = () => window.location.origin;

// Backend API reached through the front proxy, e.g. "https://essuivi.com/coreService"
export const getCoreServiceUrl = () => `${getAppOrigin()}/coreService`;

// Direct backend origin (used for websockets), e.g. "https://back.essuivi.com"
export const getBackendOrigin = () => {
	if (isLocalhost()) return process.env.REACT_APP_BACKEND_DOMAIN || 'http://localhost:3001';
	const { protocol, hostname } = window.location;
	return `${protocol}//back.${hostname.replace(/^www\./, '')}`;
};
